export default __webpack_public_path__ + "static/media/meatchops.c179d3ed.jpg";